import React, { useContext } from 'react';
import { ThemeContext } from 'Context';
import { Wrapper, IconWrapper, MoonIcon, SunIcon } from './styled';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useContext(ThemeContext);

  return (
    <Wrapper>
      <IconWrapper onClick={ toggleTheme } title="Toggle theme" role="button" aria-label="Toggle theme">
        { theme === 'dark' ? <SunIcon /> : <MoonIcon /> }
      </IconWrapper>
    </Wrapper>
  );
};

export default ThemeToggle;
